import { BellIcon } from '@/shared/ui/icons';
import { cn } from '@/shared/utils/cn';

type NotificationBellProps = {
  label: string;
  count?: number;
  onClick: () => void;
  className?: string;
};

export const NotificationBell = ({ label, count = 0, onClick, className }: NotificationBellProps) => {
  const badge = count > 99 ? '99+' : String(count);
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={onClick}
      className={cn(
        'relative inline-flex cursor-pointer items-center justify-center text-slate-700 transition-colors hover:text-brand-600',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40',
        className,
      )}
    >
      <BellIcon className="h-6 w-6" />
      {count > 0 && (
        <span
          aria-hidden
          className="pointer-events-none absolute -right-1.5 -top-1.5 inline-flex min-w-4 items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-semibold leading-4 text-white"
        >
          {badge}
        </span>
      )}
    </button>
  );
};
